export const getMethods = {
  getChangLongTab: (lotteryType) => {
    let returnArray
    switch (lotteryType) {
      case 'pk10':
      case 'kl10':
        returnArray = [
          {
            label: '单长龙',
            ruleType: 'hmDanShuang',
            ruleCode: 'danshuang_dan',
            headerLabel: '单'
          },
          {
            label: '双长龙',
            ruleType: 'hmDanShuang',
            ruleCode: 'danshuang_shuang',
            headerLabel: '双'
          },
          {
            label: '大长龙',
            ruleType: 'hmDaXiao',
            ruleCode: 'daxiao_da',
            headerLabel: '大'
          },
          {
            label: '小长龙',
            ruleType: 'hmDaXiao',
            ruleCode: 'daxiao_xiao',
            headerLabel: '小'
          },
          {
            label: '龙长龙',
            ruleType: 'zuLongHu',
            ruleCode: 'longHu_long',
            headerLabel: '龙'
          },
          {
            label: '虎长龙',
            ruleType: 'zuLongHu',
            ruleCode: 'longHu_hu',
            headerLabel: '虎'
          }
        ]
        break
      case 'k3':
      case 'kl8':
      case 'xy28':
        returnArray = [
          {
            label: '单长龙',
            ruleType: 'zongHeDanShuang',
            ruleCode: 'danshuang_dan',
            headerLabel: '单'
          },
          {
            label: '双长龙',
            ruleType: 'zongHeDanShuang',
            ruleCode: 'danshuang_shuang',
            headerLabel: '双'
          },
          {
            label: '大长龙',
            ruleType: 'zongHeDaXiao',
            ruleCode: 'daxiao_da',
            headerLabel: '大'
          },
          {
            label: '小长龙',
            ruleType: 'zongHeDaXiao',
            ruleCode: 'daxiao_xiao',
            headerLabel: '小'
          }
        ]
        break
      case 'ssc':
      case '11x5':
        returnArray = [
          {
            label: '单长龙',
            ruleType: 'hmDanShuang',
            ruleCode: 'danshuang_dan',
            headerLabel: '单'
          },
          {
            label: '双长龙',
            ruleType: 'hmDanShuang',
            ruleCode: 'danshuang_shuang',
            headerLabel: '双'
          },
          {
            label: '大长龙',
            ruleType: 'hmDaXiao',
            ruleCode: 'daxiao_da',
            headerLabel: '大'
          },
          {
            label: '小长龙',
            ruleType: 'hmDaXiao',
            ruleCode: 'daxiao_xiao',
            headerLabel: '小'
          },
          {
            label: '龙长龙',
            ruleType: 'longHu',
            ruleCode: 'longHu_long',
            headerLabel: '龙'
          },
          {
            label: '虎长龙',
            ruleType: 'longHu',
            ruleCode: 'longHu_hu',
            headerLabel: '虎'
          }
        ]
        break
    }
    if (lotteryType === 'xy28') {
      return returnArray.concat([{
        label: '红波长龙',
        ruleType: 'seBo',
        ruleCode: 'yanse_hong',
        headerLabel: '红波'
      },
      {
        label: '绿波长龙',
        ruleType: 'seBo',
        ruleCode: 'yanse_lyu',
        headerLabel: '绿波'
      },
      {
        label: '蓝波长龙',
        ruleType: 'seBo',
        ruleCode: 'yanse_lan',
        headerLabel: '蓝波'
      }])
    } else if (lotteryType === 'kl10') {
      return returnArray.concat([{
        label: '尾大长龙',
        ruleType: 'hmWeiShuDaXiao',
        ruleCode: 'daxiao_da',
        headerLabel: '尾大'
      },
      {
        label: '尾小长龙',
        ruleType: 'hmWeiShuDaXiao',
        ruleCode: 'daxiao_xiao',
        headerLabel: '尾小'
      },
      {
        label: '合单长龙',
        ruleType: 'hmHeDanShuang',
        ruleCode: 'danshuang_dan',
        headerLabel: '合单'
      },
      {
        label: '合双长龙',
        ruleType: 'hmHeDanShuang',
        ruleCode: 'danshuang_shuang',
        headerLabel: '合双'
      }])
    }
    return returnArray
  },
  getfieldsTab: ({ lotteryType, ruleType, ruleCode }) => {
    switch (lotteryType) {
      case 'pk10':
        if (ruleType === 'zuLongHu') {
          return (new Array(5)).fill().map((nothing, index) => {
            const returnObject = {
              field: `group${index + 1}_${10 - index}`,
              ruleType,
              ruleCode
            }
            switch (index) {
              case 0:
                returnObject['label'] = '冠军'
                break
              case 1:
                returnObject['label'] = '亚军'
                break
              case 2:
                returnObject['label'] = '第三名'
                break
              case 3:
                returnObject['label'] = '第四名'
                break
              case 4:
                returnObject['label'] = '第五名'
                break
            }
            return returnObject
          })
        } else {
          const returnArray = (new Array(10).fill().map((nothing, index) => {
            const returnObject = {
              field: `hm${index + 1}`,
              ruleType,
              ruleCode
            }
            switch (index) {
              case 0:
                returnObject['label'] = '冠军'
                break
              case 1:
                returnObject['label'] = '亚军'
                break
              case 2:
                returnObject['label'] = '第三名'
                break
              case 3:
                returnObject['label'] = '第四名'
                break
              case 4:
                returnObject['label'] = '第五名'
                break
              case 5:
                returnObject['label'] = '第六名'
                break
              case 6:
                returnObject['label'] = '第七名'
                break
              case 7:
                returnObject['label'] = '第八名'
                break
              case 8:
                returnObject['label'] = '第九名'
                break
              case 9:
                returnObject['label'] = '第十名'
                break
            }
            return returnObject
          }))
          returnArray.push({
            label: '冠亚和',
            field: 'sumguanya',
            ruleType,
            ruleCode
          })
          return returnArray
        }
      case '11x5':
      case 'ssc':
        if (/^hm/.test(ruleType)) {
          const returnArray = (new Array(5).fill().map((nothing, index) => {
            const returnObject = {
              field: `hm${index + 1}`,
              ruleType,
              ruleCode
            }
            switch (index) {
              case 0:
                returnObject['label'] = '第一球'
                break
              case 1:
                returnObject['label'] = '第二球'
                break
              case 2:
                returnObject['label'] = '第三球'
                break
              case 3:
                returnObject['label'] = '第四球'
                break
              case 4:
                returnObject['label'] = '第五球'
                break
            }
            return returnObject
          }))
          returnArray.push({
            label: '总和',
            field: 'all',
            ruleType,
            ruleCode
          })
          return returnArray
        } else if (/^zongHe/.test(ruleType)) {
          return [{
            label: '尾数',
            field: 'allmantissa',
            ruleType,
            ruleCode
          }]
        } else if (ruleType === 'longHu') {
          return [{
            label: '第一球VS第五球',
            field: 'all',
            ruleType,
            ruleCode
          }]
        } else return []
      case 'k3':
      case 'xy28':
      case 'kl8':
        return [{
          label: '总和',
          field: 'all',
          ruleType,
          ruleCode
        }]
      case 'kl10':
        if (ruleType === 'zuLongHu') {
          return (new Array(4)).fill().map((nothing, index) => {
            const returnObject = {
              field: `group${index + 1}_${8 - index}`,
              ruleType,
              ruleCode
            }
            switch (index) {
              case 0:
                returnObject['label'] = '第一球'
                break
              case 1:
                returnObject['label'] = '第二球'
                break
              case 2:
                returnObject['label'] = '第三球'
                break
              case 3:
                returnObject['label'] = '第四球'
                break
            }
            return returnObject
          })
        } else {
          const returnArray = (new Array(8).fill().map((nothing, index) => {
            const returnObject = {
              field: `hm${index + 1}`,
              ruleType,
              ruleCode
            }
            switch (index) {
              case 0:
                returnObject['label'] = '冠军'
                break
              case 1:
                returnObject['label'] = '亚军'
                break
              case 2:
                returnObject['label'] = '第三名'
                break
              case 3:
                returnObject['label'] = '第四名'
                break
              case 4:
                returnObject['label'] = '第五名'
                break
              case 5:
                returnObject['label'] = '第六名'
                break
              case 6:
                returnObject['label'] = '第七名'
                break
              case 7:
                returnObject['label'] = '第八名'
                break
            }
            return returnObject
          }))
          if (/^hmWeiShu/.test(ruleType)) {
            returnArray.push({
              label: '总和',
              field: 'allmantissa',
              ruleType,
              ruleCode
            })
          } else if (/^hm(?!He)/.test(ruleType)) {
            returnArray.push({
              label: '总和',
              field: 'all',
              ruleType,
              ruleCode
            })
          }
          return returnArray
        }
    }
  }
}
